import React, {useState, useEffect} from 'react'

function SPA_fills({short_term_type, setSpafills, setSPA}) {
    const [name, setName] = useState('')
    const [location, setLocation] = useState('')
    const [duration, setDuration] = useState('')
    const [phone, setPhone] = useState('')
    const [altphone, setAltphone] = useState('')
    const [date, setDate] = useState('')
   
    const [loading, setLoading] = useState(false)

     const scroll = () =>{
        
      if (name==''||location==''||duration==''||phone==''||altphone==''||date=='') {
            
        if(name=='')alert('please add your name')
        if(location=='') alert('please add your Intersted Location')
        if(duration=='') alert('please add your Duration')
        if(altphone=='') alert('please add your alternative phone number')
        if(phone=='') alert('please add your phone number')
        if(date=='') alert('please select your date of admission')

    } 
    
    else 
    {
      setLoading(true)
      fetch('https://hosteladventures.site/PHP/Booking/short_term_booking.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
           name,
           location,
           duration,
           phone,
           altphone,
           date,
           short_term_type
        })
      })
        .then(response => response.json())
        .then(data => {
          // Handle response from backend (e.g., login success or failure)
          if(data.message=='in')
          {
            setLoading(false)
            alert('Thank you for booking with us, we will contact you within the next 24 hours')
             
            setSPA(true)
            setSpafills(false)
          }

         
       
        })
        .catch(error => {
          console.error('Error:', error);
          alert('Error Uploading,!! Check Internet Connection')
          setLoading(false)
        });
     
    }
     
    }


  return (
    <div className='Form_HBK'>
        <p className='fill_In'>Book {short_term_type}</p>

        <input placeholder='Name' onChange={(event) => setName(event.target.value)} />
        <input placeholder='Interested Location' onChange={(event) => setLocation(event.target.value)} />
        <input placeholder='Expected Stay Duration' onChange={(event) => setDuration(event.target.value)} />
            
            <div>
              <div className='DOM_PH'>Expected Reporting Date:</div>
              <input type='date' placeholder='date of admission' onChange={(event) => setDate(event.target.value)} />
            </div>
                        
        <input placeholder='Phone Number' onChange={(event) => setPhone(event.target.value)}/>
        <input placeholder='Aternative Phone Number' onChange={(event) => setAltphone(event.target.value)} />

        {!loading?(<div className='submit' onClick={scroll}>Submit</div>):(<div className='submit'>Loading...</div>)}
    </div>
  )
}

export default SPA_fills
